var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.490471 2.45704C0 3.41965 0 4.67976 0 7.2V16.8C0 19.3202 0 20.5804 0.490471 21.543C0.921901 22.3897 1.61031 23.0781 2.45704 23.5095C3.41965 24 4.67976 24 7.2 24H16.8C19.3202 24 20.5804 24 21.543 23.5095C22.3897 23.0781 23.0781 22.3897 23.5095 21.543C24 20.5804 24 19.3202 24 16.8V7.2C24 4.67976 24 3.41965 23.5095 2.45704C23.0781 1.61031 22.3897 0.921901 21.543 0.490471C20.5804 0 19.3202 0 16.8 0H7.2C4.67976 0 3.41965 0 2.45704 0.490471C1.61031 0.921901 0.921901 1.61031 0.490471 2.45704ZM8.5 7C8.5 5.89543 9.39543 5 10.5 5H13.5C14.6046 5 15.5 5.89543 15.5 7V8H18V10H14.5H9.5H6V8H8.5V7ZM10.5 8H13.5V7H10.5V8ZM8 11V17C8 17.5523 8.44772 18 9 18H15C15.5523 18 16 17.5523 16 17V11H14V16.5H13V11H11V16.5H10V11H8Z",
    fill: "var(--on-surface)"
  })));
};
export default SvgDelete;